import html2canvas from "html2canvas";

const getFullPageSize = () => {
  const { body, documentElement } = document;
  return {
    width: Math.max(
      body.scrollWidth,
      body.offsetWidth,
      documentElement.clientWidth,
      documentElement.scrollWidth,
      documentElement.offsetWidth,
    ),
    height: Math.max(
      body.scrollHeight,
      body.offsetHeight,
      documentElement.clientHeight,
      documentElement.scrollHeight,
      documentElement.offsetHeight,
    ),
  };
};

const getCaptureFileName = () => {
  const tenant = (localStorage.getItem("Tenant") || "page").replace(
    /[^a-zA-Z0-9_-]/g,
    "-",
  );
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  return `carmen-${tenant}-${timestamp}.png`;
};

const downloadCanvas = (canvas) =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Cannot create screenshot file."));
        return;
      }

      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = getCaptureFileName();
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
      resolve();
    }, "image/png");
  });

export default async function captureFullPage() {
  const { width, height } = getFullPageSize();
  const canvas = await html2canvas(document.body, {
    width,
    height,
    windowWidth: width,
    windowHeight: height,
    scrollX: 0,
    scrollY: 0,
    useCORS: true,
    scale: 1,
    backgroundColor: window.getComputedStyle(document.body).backgroundColor,
    ignoreElements: (element) =>
      element.hasAttribute("data-html2canvas-ignore") ||
      element.classList.contains("swal2-deny"),
  });
  await downloadCanvas(canvas);
}
